import type {
  RouteLocationNormalized,
  RouteLocationRaw,
} from 'vue-router';
import { useAccountStore } from '@/stores/account';
import {
  MULTI_TRANSACTION_RFQ_QUERY_PARAM,
  MULTI_TRANSACTION_RFQ_QUERY_VALUE,
  RFQ_ROUTE_NAMES,
  RFQ_ROUTE_PATHS,
} from '@/shared/common/constants/rfqRoutes.constant';

function isRfqPath(matched: RouteLocationNormalized['matched']): boolean {
  const basePath = RFQ_ROUTE_PATHS[RFQ_ROUTE_NAMES.HUB];

  return matched.some((record) => record.path === basePath);
}

function isRfqFlowQuery(query: RouteLocationNormalized['query']): boolean {
  return (
    query[MULTI_TRANSACTION_RFQ_QUERY_PARAM] === MULTI_TRANSACTION_RFQ_QUERY_VALUE
  );
}

/**
 * Impide el acceso a Mesa de dinero (RFQ) para empresas institucionales.
 * Decide por el record resuelto y no por el texto de la URL, que puede venir en mayúsculas.
 * `/rfq/send` es un redirect a `/multi-transaction?flow=rfq` que vue-router resuelve
 * antes del guard, por eso también se mira el query y no solo el path.
 */
export function validateRfqInstitutionalAccess(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized
): boolean | RouteLocationRaw {
  if (!isRfqPath(to.matched) && !isRfqFlowQuery(to.query)) {
    return true;
  }

  const accountStore = useAccountStore();
  const isInstitutional = Boolean(accountStore.kycStatus?.company?.institutional);

  if (isInstitutional) {
    return { name: 'movements' };
  }

  return true;
}
